import { type Editor } from '@tiptap/react'
import { Card } from '#app/components/ui/card.js'
import { Input } from '#app/components/ui/input.js'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '#app/components/ui/select.js'

export const SimpleFormSettings = ({
	pos,
	node,
	editor,
}: {
	pos: number
	node: any
	editor: Editor
}) => {
	return (
		<div className="flex flex-col gap-2">
			<p className="text-xs uppercase text-label">FORM SETTINGS</p>
			<p className="font-medium">State</p>
			<Select
				onValueChange={value => {
					editor
						.chain()
						.setNodeSelection(pos)
						.setSimpleFormState(
							value as 'Success' | 'Error' | 'Idle' | 'Loading',
						)
						.run()
				}}
				defaultValue={node.attrs.state}
			>
				<SelectTrigger>
					<SelectValue placeholder={node.attrs.state} />
				</SelectTrigger>
				<SelectContent>
					{['Success', 'Idle'].map(option => (
						<SelectItem key={option} value={option}>
							{option}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
			<p className="font-medium">Redirect on success</p>
			<Card variant="filled">
				<p>
					By default the form shows a simple success state, you can redirect to
					any given url instead.
				</p>
			</Card>
			<Input
				type="url"
				placeholder="https://"
				variant="s"
				icon="Link2"
				onChange={e =>
					editor
						.chain()
						.setNodeSelection(pos)
						.setSimpleFormRedirectUrl(e.currentTarget.value)
						.run()
				}
				defaultValue={node.attrs.redirectUrl}
			/>
		</div>
	)
}

export default SimpleFormSettings
